import { EntryNameDialog } from "@/components/file-tree/EntryNameDialog";

interface NewFileDialogProps {
	open: boolean;
	onConfirm: (name: string) => Promise<void>;
	onCancel: () => void;
}

export function NewFileDialog({ open, onConfirm, onCancel }: NewFileDialogProps) {
	return (
		<EntryNameDialog
			open={open}
			title="新規ファイル"
			label="ファイル名"
			confirmLabel="作成"
			testIdPrefix="new-file-dialog"
			onConfirm={onConfirm}
			onCancel={onCancel}
		/>
	);
}
